import darkLogo from '../../assets/images/darkLogo.svg';
import { useNavigate } from 'react-router-dom'

function BrainyDash() {
    const navigate = useNavigate()
    return (
        <div className='home'>
            <div className="header">
                <img src={darkLogo} alt="logo" onClick={() => navigate('/')} />
                <div className='d-flex align-items-center gap-2'>
                    <button className='theme-rounded-btn'
                        onClick={() => { localStorage.removeItem('token'); navigate('/') }}>
                        Log out
                    </button>
                </div>
            </div>
        </div>
    )
}

export default BrainyDash